import ClientProductWithHierarchy from "@/models/Agents/ProductWithHierarchy";

export default class MatchProblemProduct extends ClientProductWithHierarchy {
  static type = "clientsMatchProblemProduct";

  matched!: boolean;
  isMultiple!: boolean;
}
